import { DataDisplayEvent, DataSourceMode, Label, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutHandlingRequirementsCompareChangeItem } from "./autogen/AutogenLayoutHandlingRequirementsCompareChangeItem";
import { ModelRow, StringUtil } from "@mcleod/core";
import { BaseCompare } from "./BaseCompare";

export class HandlingRequirementsCompareChangeItem extends AutogenLayoutHandlingRequirementsCompareChangeItem {
    private _compareItems: ModelRow[];
    private _isCompareHistory: boolean = false;
    private _isOrderUpdateAllowed: boolean = true;
    private baseCompare = new BaseCompare();


    public get isOrderUpdateAllowed(): boolean {
        return this._isOrderUpdateAllowed;
    }

    public set isOrderUpdateAllowed(value: boolean) {
        this._isOrderUpdateAllowed = value;
    }

    public async setupTableData(data: ModelRow[]) {
        this._compareItems = data;
    }

    override onLoad(): void | Promise<void> {
        this.tableHandlingChangeItems.dataSource = this.sourceEdiCompareItem;
        this.tableHandlingChangeItems.dataSource.data = [];
        if (this._compareItems != null) {
            if (this._compareItems.length === 0) {
                this.tableHandlingChangeItems.visible = false;
            } else {
                this.tableHandlingChangeItems.dataSource.setRowsAndMode(DataSourceMode.NONE, this._compareItems);
            }
        }
    }

    onItemRowDisplay(event: TableRowDisplayEvent) {
        this.baseCompare.isOrderUpdateAllowed = this.isOrderUpdateAllowed;
        this.baseCompare.isCompareHistory = this.isCompareHistory;
        this.baseCompare.setupCheckboxBehavior(event.getTableRow(), this.isOrderUpdateAllowed, false);
    }



    valueOnDisplay(event: DataDisplayEvent) {
        const label = event.target as Label;
        if (label.text == "1900-01-01") {
            label.text = "";
        }
    }

    onDescrDisplay(event: DataDisplayEvent) {
        const labelDescr = <Label>event.target
        if (StringUtil.isEmptyString(event.rowData.get("target_descr"))) {
            labelDescr.text = event.rowData.get("source_descr");
        }
        if (event.rowData.get("handling_req_value") !== null && event.rowData.get("handling_req_value") !== undefined) {
            labelDescr.text = event.rowData.get("handling_req_value");
        }
    }

    public get isCompareHistory(): boolean {
        return this._isCompareHistory;
    }

    public set isCompareHistory(isCompareHistory: boolean) {
        this._isCompareHistory = isCompareHistory;
    }
}